import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppComponent } from './app.component';
import { AppService } from './app.service';
import { BondCalculatorModule } from './bond-calculator/bond-calculator.module';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InstrumentPillModule } from '../assets/shared/component/instrument-pill';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormattingModule } from '@vwd/ngx-i18n';
import { LocalDataService, LocalStorageService } from '../assets/shared/utils/ngx-utils/storage';
import { RouterModule } from '@angular/router';


export function init_app(appLoadService: AppService) {
  return () => appLoadService.initializeApp();
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BondCalculatorModule,
    HttpClientModule,
    BrowserAnimationsModule,
    InstrumentPillModule,
    RouterModule.forRoot([]),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormattingModule.forRoot({
      nullText: '--',
      numberFormats: {
        'price': { pattern: '#,##0.00' },
        'price[percentTraded]': { pattern: '#,##0.00 "%"' },
        'price[withCurrency]': [
          ['*', { pattern: '¤#,##0.00', roundBeforeFormat: false }],
          ['de', { pattern: '#,##0.00 ¤', roundBeforeFormat: false }],
          ['fr', { pattern: '#,##0.00 ¤', roundBeforeFormat: false }],
          ['it', { pattern: '#,##0.00 ¤', roundBeforeFormat: false }],
          ['nl', { pattern: '¤ #,##0.00;¤ -#,##0.00', roundBeforeFormat: false }],
        ],
        'price[withCurrency=XXZ]': [
          ['*', { pattern: '#,##0.00 pct' }],
          ['de', { pattern: '#,##0.00 Pct' }],
        ],
        'price[withCurrency=XXP]': [
          ['*', { pattern: '#,##0.00 pt' }],
          ['de', { pattern: '#,##0.00 Pkt' }],
        ],
        'pctChange': { pattern: '+#,##0.00"%";-#,##0.00"%";±#,##0.00"%"', roundBeforeFormat: false },
        'netChange': { pattern: '+#,##0.00;-#,##0.00;±#,##0.00', roundBeforeFormat: false },
        'netChange[percentTraded]': { pattern: '+#,##0.00 "%";-#,##0.00 "%";±#,##0.00 "%"', roundBeforeFormat: false },
        'netChange[withCurrency]': [
          ['*', { pattern: '¤+#,##0.00;¤-#,##0.00;¤±#,##0.00', roundBeforeFormat: false }],
          ['de', { pattern: '+#,##0.00 ¤;-#,##0.00 ¤;±#,##0.00 ¤', roundBeforeFormat: false }],
          ['fr', { pattern: '+#,##0.00 ¤;-#,##0.00 ¤;±#,##0.00 ¤', roundBeforeFormat: false }],
          ['it', { pattern: '+#,##0.00 ¤;-#,##0.00 ¤;±#,##0.00 ¤', roundBeforeFormat: false }],
          ['nl', { pattern: '¤ +#,##0.00;¤ -#,##0.00;¤ ±#,##0.00', roundBeforeFormat: false }],
        ],
        'netChange[withCurrency=XXZ]': [
          ['*', { pattern: '+#,##0.00 pct;-#,##0.00 pct;±#,##0.00 pct', roundBeforeFormat: false }],
          ['de', { pattern: '+#,##0.00 Pct;-#,##0.00 Pct;±#,##0.00 Pct', roundBeforeFormat: false }],
        ],
        'netChange[withCurrency=XXP]': [
          ['*', { pattern: '+#,##0.00 pt;-#,##0.00 pt;±#,##0.00 pt', roundBeforeFormat: false }],
          ['de', { pattern: '+#,##0.00 Pkt;-#,##0.00 Pkt;±#,##0.00 Pkt', roundBeforeFormat: false }],
        ],
      }
    }, TranslateService),
  ],
  providers: [AppService, LocalDataService, LocalStorageService,
    { provide: APP_INITIALIZER, useFactory: init_app, deps: [AppService, TranslateService], multi: true },
    // { provide: APP_INITIALIZER, useFactory: get_settings, deps: [AppService], multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
